import styled, { css } from 'styled-components';

import { ChevronRight, ChevronLeft } from '@gympass/yoga-icons';

export const TabMenu = styled.ul<{
  selectedIndex: number;
}>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: start;
  overflow: scroll;
  -ms-overflow-style: none;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }

  a {
    color: ${({ theme }) => theme.yoga.colors.deep};
    line-height: ${({ theme }) => theme.yoga.lineHeights.medium}px;
    letter-spacing: ${({ theme }) => theme.yoga.spacing.zero}px;
    text-align: center;
    width: ${({ theme }) => theme.yoga.sizes.tabItemLink}px;
    margin: 0px ${({ theme }) => theme.yoga.spacing.small}px;
    font-weight: ${({ theme }) => theme.yoga.fontWeights.medium};
  }

  li:nth-child(${({ selectedIndex }) => selectedIndex}) {
    border-bottom-color: ${({ theme }) => theme.yoga.colors.primary};
    a {
      color: ${({ theme }) => theme.yoga.colors.primary};
      font-weight: ${({ theme }) => theme.yoga.fontWeights.medium};
    }
  }
`;

export const TabContainer = styled.div`
  display: flex;
  padding: ${({ theme }) => theme.yoga.spacing.xsmall}px 0px;
  margin-top: ${({ theme }) => theme.yoga.spacing.medium}px;
`;

export const MonthItem = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  min-width: ${({ theme }) => theme.yoga.sizes.tabItemWidth}px;
  border-bottom: none;
  color: ${({ theme }) => theme.yoga.colors.deep};
  line-height: ${({ theme }) => theme.yoga.lineHeights.medium}px;
  letter-spacing: ${({ theme }) => theme.yoga.spacing.zero}px;
  text-align: center;
  width: ${({ theme }) => theme.yoga.sizes.tabItemLink}px;
  margin: 0px ${({ theme }) => theme.yoga.spacing.small}px;
  font-weight: ${({ theme }) => theme.yoga.fontWeights.medium};
`;

export const MonthItemPrimary = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  min-width: ${({ theme }) => theme.yoga.sizes.tabItemWidth}px;
  border-bottom: ${({ theme }) => theme.yoga.borders.medium}px solid
    ${({ theme }) => theme.yoga.colors.primary};
  color: ${({ theme }) => theme.yoga.colors.primary};
  line-height: ${({ theme }) => theme.yoga.lineHeights.medium}px;
  letter-spacing: ${({ theme }) => theme.yoga.spacing.zero}px;
  text-align: center;
  width: ${({ theme }) => theme.yoga.sizes.tabItemLink}px;
  margin: ${({ theme }) => theme.yoga.spacing.zero}px
    ${({ theme }) => theme.yoga.spacing.small}px;
  font-weight: ${({ theme }) => theme.yoga.fontWeights.medium};
`;

export const MonthContainer = styled.div`
  display: flex;
  overflow: scroll;
  -ms-overflow-style: none;
  scrollbar-width: none;
  width: 100%;

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const ArrowRight = styled.div`
  position: relative;
  right: 0%;
  padding-right: ${({ theme }) => theme.yoga.spacing.medium}px;
  padding-top: ${({ theme }) => theme.yoga.spacing.xxxsmall}px;
  cursor: pointer;
`;

export const ArrowLeft = styled.div`
  position: relative;
  left: 0%;
  padding-left: ${({ theme }) => theme.yoga.spacing.medium}px;
  padding-top: ${({ theme }) => theme.yoga.spacing.xxxsmall}px;
  cursor: pointer;
`;

export const TabItem = styled.li`
  display: flex;
  align-items: center;
  white-space: nowrap;

  width: ${({ theme }) => theme.yoga.sizes.tabItemWidth}px;
  border-bottom: ${({ theme }) => theme.yoga.borders.medium}px solid transparent;
  padding: 10px ${({ theme }) => theme.yoga.spacing.zero}px;
`;

const iconsStyle = css`
  fill: ${({ theme }) => theme.yoga.colors.checkboxBorderColor};
  width: ${({ theme }) => theme.yoga.spacing.large}px;
  height: ${({ theme }) => theme.yoga.spacing.large}px;
`;

export const StyledChevronLeft = styled(ChevronLeft)`
  ${iconsStyle}
`;

export const StyledChevronRight = styled(ChevronRight)`
  ${iconsStyle}
`;
